/**
 * Layout Component
 * Basic app shell with header and navigation placeholder for AWL Shopping Agent.
 */

import { ReactNode } from 'react';
import { useAuth } from '../contexts/AuthContext';
import OtterChat from './OtterChat';
import Footer from './Footer';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const { user, signOut } = useAuth();

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Sign out failed:', error);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border bg-card">
        <div className="container mx-auto flex h-16 items-center justify-between px-4">
          <div className="flex items-center gap-6">
            <h1 className="text-xl font-semibold text-foreground">
              AWL Shopping Agent
            </h1>
            <nav className="hidden md:flex items-center gap-4">
              <a
                href="/dashboard"
                className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
              >
                Dashboard
              </a>
            </nav>
          </div>
          <div className="flex items-center gap-4">
            {user && (
              <span className="text-sm text-muted-foreground">
                {user.email}
              </span>
            )}
            <button
              onClick={handleSignOut}
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
            >
              Sign Out
            </button>
          </div>
        </div>
      </header>
      <main className="container mx-auto px-4 py-6">
        {children}
      </main>
      <div className="mt-16">
        <Footer />
      </div>
      <OtterChat />
    </div>
  );
}
